// Realtime game channel: reliable, ordered messages (WebTransport bidirectional stream frames or
// WebSocket channel 0x01, see docs/NETCODE.md). Each frame carries exactly one ClientMessage or
// ServerMessage in binary protobuf.
//
// The 60 Hz unreliable traffic (input packets, snapshots, ping/pong) is NOT protobuf: it uses the
// bit-packed codec in gr_core::protocol, which the client runs through WebAssembly, so both ends
// share one implementation.

// @generated by protoc-gen-es v2.16.0 with parameter "target=ts,import_extension=none"
// @generated from file gunrun/v1/game.proto (package gunrun.v1, syntax proto3)
/* eslint-disable */

import type { GenEnum, GenFile, GenMessage } from "@bufbuild/protobuf/codegenv2";
import { enumDesc, fileDesc, messageDesc } from "@bufbuild/protobuf/codegenv2";
import type { BotDifficulty, GameMode, HitZone, Loadout, MatchPhase, ModeRules, RoomKind, Team, TeamScores, Vec3 } from "./common_pb";
import { file_gunrun_v1_common } from "./common_pb";
import type { Message } from "@bufbuild/protobuf";

/**
 * Describes the file gunrun/v1/game.proto.
 */
export const file_gunrun_v1_game: GenFile = /*@__PURE__*/
  fileDesc("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", [file_gunrun_v1_common]);

/**
 * @generated from message gunrun.v1.ClientMessage
 */
export type ClientMessage = Message<"gunrun.v1.ClientMessage"> & {
  /**
   * @generated from oneof gunrun.v1.ClientMessage.msg
   */
  msg: {
    /**
     * @generated from field: gunrun.v1.Hello hello = 1;
     */
    value: Hello;
    case: "hello";
  } | {
    /**
     * @generated from field: gunrun.v1.Ready ready = 2;
     */
    value: Ready;
    case: "ready";
  } | {
    /**
     * @generated from field: gunrun.v1.SelectLoadout select_loadout = 3;
     */
    value: SelectLoadout;
    case: "selectLoadout";
  } | {
    /**
     * @generated from field: gunrun.v1.SelectTeam select_team = 4;
     */
    value: SelectTeam;
    case: "selectTeam";
  } | {
    /**
     * @generated from field: gunrun.v1.ChatSend chat = 5;
     */
    value: ChatSend;
    case: "chat";
  } | {
    /**
     * @generated from field: gunrun.v1.HostCommand host = 6;
     */
    value: HostCommand;
    case: "host";
  } | {
    /**
     * @generated from field: gunrun.v1.Leave leave = 7;
     */
    value: Leave;
    case: "leave";
  } | {
    /**
     * @generated from field: gunrun.v1.CycleSpectate cycle_spectate = 8;
     */
    value: CycleSpectate;
    case: "cycleSpectate";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gunrun.v1.ClientMessage.
 * Use `create(ClientMessageSchema)` to create a new message.
 */
export const ClientMessageSchema: GenMessage<ClientMessage> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 0);

/**
 * First message on a new connection.
 *
 * @generated from message gunrun.v1.Hello
 */
export type Hello = Message<"gunrun.v1.Hello"> & {
  /**
   * @generated from field: uint32 protocol_version = 1;
   */
  protocolVersion: number;
};

/**
 * Describes the message gunrun.v1.Hello.
 * Use `create(HelloSchema)` to create a new message.
 */
export const HelloSchema: GenMessage<Hello> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 1);

/**
 * Map loaded; the server may spawn the player.
 *
 * @generated from message gunrun.v1.Ready
 */
export type Ready = Message<"gunrun.v1.Ready"> & {
};

/**
 * Describes the message gunrun.v1.Ready.
 * Use `create(ReadySchema)` to create a new message.
 */
export const ReadySchema: GenMessage<Ready> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 2);

/**
 * Loadout slot (0..4) used from the next spawn on.
 *
 * @generated from message gunrun.v1.SelectLoadout
 */
export type SelectLoadout = Message<"gunrun.v1.SelectLoadout"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;
};

/**
 * Describes the message gunrun.v1.SelectLoadout.
 * Use `create(SelectLoadoutSchema)` to create a new message.
 */
export const SelectLoadoutSchema: GenMessage<SelectLoadout> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 3);

/**
 * @generated from message gunrun.v1.SelectTeam
 */
export type SelectTeam = Message<"gunrun.v1.SelectTeam"> & {
  /**
   * @generated from field: gunrun.v1.Team team = 1;
   */
  team: Team;
};

/**
 * Describes the message gunrun.v1.SelectTeam.
 * Use `create(SelectTeamSchema)` to create a new message.
 */
export const SelectTeamSchema: GenMessage<SelectTeam> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 4);

/**
 * @generated from message gunrun.v1.ChatSend
 */
export type ChatSend = Message<"gunrun.v1.ChatSend"> & {
  /**
   * @generated from field: bool team_only = 1;
   */
  teamOnly: boolean;

  /**
   * <= 200 characters
   *
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message gunrun.v1.ChatSend.
 * Use `create(ChatSendSchema)` to create a new message.
 */
export const ChatSendSchema: GenMessage<ChatSend> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 5);

/**
 * @generated from message gunrun.v1.Leave
 */
export type Leave = Message<"gunrun.v1.Leave"> & {
};

/**
 * Describes the message gunrun.v1.Leave.
 * Use `create(LeaveSchema)` to create a new message.
 */
export const LeaveSchema: GenMessage<Leave> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 6);

/**
 * Dead player in a mode where the dead watch their team (Defusal): watch the next living teammate.
 *
 * @generated from message gunrun.v1.CycleSpectate
 */
export type CycleSpectate = Message<"gunrun.v1.CycleSpectate"> & {
};

/**
 * Describes the message gunrun.v1.CycleSpectate.
 * Use `create(CycleSpectateSchema)` to create a new message.
 */
export const CycleSpectateSchema: GenMessage<CycleSpectate> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 7);

/**
 * @generated from message gunrun.v1.StartMatch
 */
export type StartMatch = Message<"gunrun.v1.StartMatch"> & {
};

/**
 * Describes the message gunrun.v1.StartMatch.
 * Use `create(StartMatchSchema)` to create a new message.
 */
export const StartMatchSchema: GenMessage<StartMatch> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 8);

/**
 * Custom lobby host controls.
 *
 * @generated from message gunrun.v1.HostCommand
 */
export type HostCommand = Message<"gunrun.v1.HostCommand"> & {
  /**
   * @generated from oneof gunrun.v1.HostCommand.cmd
   */
  cmd: {
    /**
     * @generated from field: gunrun.v1.StartMatch start_match = 1;
     */
    value: StartMatch;
    case: "startMatch";
  } | {
    /**
     * @generated from field: string set_map = 2;
     */
    value: string;
    case: "setMap";
  } | {
    /**
     * @generated from field: gunrun.v1.GameMode set_mode = 3;
     */
    value: GameMode;
    case: "setMode";
  } | {
    /**
     * @generated from field: gunrun.v1.RoomSettings set_settings = 4;
     */
    value: RoomSettings;
    case: "setSettings";
  } | {
    /**
     * player id
     *
     * @generated from field: uint32 kick = 5;
     */
    value: number;
    case: "kick";
  } | {
    /**
     * @generated from field: gunrun.v1.AddBot add_bot = 6;
     */
    value: AddBot;
    case: "addBot";
  } | {
    /**
     * player id of a bot
     *
     * @generated from field: uint32 remove_bot = 7;
     */
    value: number;
    case: "removeBot";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gunrun.v1.HostCommand.
 * Use `create(HostCommandSchema)` to create a new message.
 */
export const HostCommandSchema: GenMessage<HostCommand> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 9);

/**
 * Adds a bot to a custom lobby (warmup only). `team` is ignored in free for all; with TEAM_NONE in a
 * team mode the smaller team gets it.
 *
 * @generated from message gunrun.v1.AddBot
 */
export type AddBot = Message<"gunrun.v1.AddBot"> & {
  /**
   * @generated from field: gunrun.v1.Team team = 1;
   */
  team: Team;

  /**
   * @generated from field: gunrun.v1.BotDifficulty difficulty = 2;
   */
  difficulty: BotDifficulty;
};

/**
 * Describes the message gunrun.v1.AddBot.
 * Use `create(AddBotSchema)` to create a new message.
 */
export const AddBotSchema: GenMessage<AddBot> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 10);

/**
 * @generated from message gunrun.v1.ServerMessage
 */
export type ServerMessage = Message<"gunrun.v1.ServerMessage"> & {
  /**
   * @generated from oneof gunrun.v1.ServerMessage.msg
   */
  msg: {
    /**
     * @generated from field: gunrun.v1.Welcome welcome = 1;
     */
    value: Welcome;
    case: "welcome";
  } | {
    /**
     * @generated from field: gunrun.v1.PlayerInfo player_joined = 2;
     */
    value: PlayerInfo;
    case: "playerJoined";
  } | {
    /**
     * @generated from field: gunrun.v1.PlayerLeft player_left = 3;
     */
    value: PlayerLeft;
    case: "playerLeft";
  } | {
    /**
     * @generated from field: gunrun.v1.PlayerInfo player_updated = 4;
     */
    value: PlayerInfo;
    case: "playerUpdated";
  } | {
    /**
     * @generated from field: gunrun.v1.Spawned spawned = 5;
     */
    value: Spawned;
    case: "spawned";
  } | {
    /**
     * @generated from field: gunrun.v1.Hit hit = 6;
     */
    value: Hit;
    case: "hit";
  } | {
    /**
     * @generated from field: gunrun.v1.Damaged damaged = 7;
     */
    value: Damaged;
    case: "damaged";
  } | {
    /**
     * @generated from field: gunrun.v1.Killed killed = 8;
     */
    value: Killed;
    case: "killed";
  } | {
    /**
     * @generated from field: gunrun.v1.Scoreboard scoreboard = 9;
     */
    value: Scoreboard;
    case: "scoreboard";
  } | {
    /**
     * @generated from field: gunrun.v1.ModeEvent mode_event = 10;
     */
    value: ModeEvent;
    case: "modeEvent";
  } | {
    /**
     * @generated from field: gunrun.v1.PhaseChanged phase_changed = 11;
     */
    value: PhaseChanged;
    case: "phaseChanged";
  } | {
    /**
     * @generated from field: gunrun.v1.MatchEnded match_ended = 12;
     */
    value: MatchEnded;
    case: "matchEnded";
  } | {
    /**
     * @generated from field: gunrun.v1.Rewards rewards = 13;
     */
    value: Rewards;
    case: "rewards";
  } | {
    /**
     * @generated from field: gunrun.v1.ChatMessage chat = 14;
     */
    value: ChatMessage;
    case: "chat";
  } | {
    /**
     * @generated from field: gunrun.v1.Notice notice = 15;
     */
    value: Notice;
    case: "notice";
  } | {
    /**
     * @generated from field: gunrun.v1.Kicked kicked = 16;
     */
    value: Kicked;
    case: "kicked";
  } | {
    /**
     * @generated from field: gunrun.v1.HostChanged host_changed = 17;
     */
    value: HostChanged;
    case: "hostChanged";
  } | {
    /**
     * @generated from field: gunrun.v1.RoomSettings room_settings = 18;
     */
    value: RoomSettings;
    case: "roomSettings";
  } | {
    /**
     * @generated from field: gunrun.v1.GlassBroken glass_broken = 19;
     */
    value: GlassBroken;
    case: "glassBroken";
  } | {
    /**
     * @generated from field: gunrun.v1.GlassRestored glass_restored = 20;
     */
    value: GlassRestored;
    case: "glassRestored";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gunrun.v1.ServerMessage.
 * Use `create(ServerMessageSchema)` to create a new message.
 */
export const ServerMessageSchema: GenMessage<ServerMessage> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 11);

/**
 * What other players can see of a loadout (weapon models and camos).
 *
 * @generated from message gunrun.v1.PublicLoadout
 */
export type PublicLoadout = Message<"gunrun.v1.PublicLoadout"> & {
  /**
   * @generated from field: string primary = 1;
   */
  primary: string;

  /**
   * @generated from field: repeated string primary_attachments = 2;
   */
  primaryAttachments: string[];

  /**
   * @generated from field: string primary_camo = 3;
   */
  primaryCamo: string;

  /**
   * @generated from field: string secondary = 4;
   */
  secondary: string;

  /**
   * @generated from field: repeated string secondary_attachments = 5;
   */
  secondaryAttachments: string[];

  /**
   * @generated from field: string secondary_camo = 6;
   */
  secondaryCamo: string;
};

/**
 * Describes the message gunrun.v1.PublicLoadout.
 * Use `create(PublicLoadoutSchema)` to create a new message.
 */
export const PublicLoadoutSchema: GenMessage<PublicLoadout> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 12);

/**
 * @generated from message gunrun.v1.PlayerInfo
 */
export type PlayerInfo = Message<"gunrun.v1.PlayerInfo"> & {
  /**
   * 0..15, stable for the connection's lifetime in the room
   *
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: string name = 2;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.Team team = 3;
   */
  team: Team;

  /**
   * @generated from field: uint32 level = 4;
   */
  level: number;

  /**
   * @generated from field: bool is_host = 5;
   */
  isHost: boolean;

  /**
   * @generated from field: gunrun.v1.PublicLoadout loadout = 6;
   */
  loadout?: PublicLoadout | undefined;

  /**
   * a server-side bot, not a connection
   *
   * @generated from field: bool is_bot = 7;
   */
  isBot: boolean;

  /**
   * only for bots
   *
   * @generated from field: gunrun.v1.BotDifficulty bot_difficulty = 8;
   */
  botDifficulty: BotDifficulty;
};

/**
 * Describes the message gunrun.v1.PlayerInfo.
 * Use `create(PlayerInfoSchema)` to create a new message.
 */
export const PlayerInfoSchema: GenMessage<PlayerInfo> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 13);

/**
 * @generated from message gunrun.v1.RoomSettings
 */
export type RoomSettings = Message<"gunrun.v1.RoomSettings"> & {
  /**
   * @generated from field: string name = 1;
   */
  name: string;

  /**
   * @generated from field: gunrun.v1.GameMode mode = 2;
   */
  mode: GameMode;

  /**
   * @generated from field: string map = 3;
   */
  map: string;

  /**
   * @generated from field: uint32 max_players = 4;
   */
  maxPlayers: number;

  /**
   * @generated from field: uint32 score_limit = 5;
   */
  scoreLimit: number;

  /**
   * @generated from field: uint32 time_limit_sec = 6;
   */
  timeLimitSec: number;

  /**
   * @generated from field: uint32 rounds_to_win = 7;
   */
  roundsToWin: number;

  /**
   * @generated from field: bool friendly_fire = 8;
   */
  friendlyFire: boolean;

  /**
   * @generated from field: bool listed = 9;
   */
  listed: boolean;

  /**
   * @generated from field: bool has_password = 10;
   */
  hasPassword: boolean;
};

/**
 * Describes the message gunrun.v1.RoomSettings.
 * Use `create(RoomSettingsSchema)` to create a new message.
 */
export const RoomSettingsSchema: GenMessage<RoomSettings> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 14);

/**
 * First reliable message from the server: everything needed to load the map and start syncing.
 *
 * @generated from message gunrun.v1.Welcome
 */
export type Welcome = Message<"gunrun.v1.Welcome"> & {
  /**
   * @generated from field: uint32 protocol_version = 1;
   */
  protocolVersion: number;

  /**
   * @generated from field: uint32 your_id = 2;
   */
  yourId: number;

  /**
   * @generated from field: string room_id = 3;
   */
  roomId: string;

  /**
   * @generated from field: string room_name = 4;
   */
  roomName: string;

  /**
   * @generated from field: gunrun.v1.RoomKind room_kind = 5;
   */
  roomKind: RoomKind;

  /**
   * @generated from field: gunrun.v1.GameMode mode = 6;
   */
  mode: GameMode;

  /**
   * @generated from field: string map = 7;
   */
  map: string;

  /**
   * FNV-1a 64 of the map JSON bytes, 16 lowercase hex chars
   *
   * @generated from field: string map_hash = 8;
   */
  mapHash: string;

  /**
   * @generated from field: uint32 tick_rate = 9;
   */
  tickRate: number;

  /**
   * @generated from field: uint32 server_tick = 10;
   */
  serverTick: number;

  /**
   * @generated from field: uint32 match_seed = 11;
   */
  matchSeed: number;

  /**
   * @generated from field: gunrun.v1.ModeRules rules = 12;
   */
  rules?: ModeRules | undefined;

  /**
   * @generated from field: repeated gunrun.v1.PlayerInfo players = 13;
   */
  players: PlayerInfo[];

  /**
   * @generated from field: optional uint32 host_id = 14;
   */
  hostId?: number | undefined;

  /**
   * @generated from field: gunrun.v1.PlayerInfo you = 15;
   */
  you?: PlayerInfo | undefined;

  /**
   * gr_core::movement::MoveConfig (serde JSON), base values before perks
   *
   * @generated from field: string move_config_json = 16;
   */
  moveConfigJson: string;

  /**
   * @generated from field: gunrun.v1.MatchPhase phase = 17;
   */
  phase: MatchPhase;

  /**
   * @generated from field: uint32 phase_end_tick = 18;
   */
  phaseEndTick: number;

  /**
   * @generated from field: gunrun.v1.RoomSettings settings = 19;
   */
  settings?: RoomSettings | undefined;

  /**
   * breakable brushes (map brush indices) already broken
   *
   * @generated from field: repeated uint32 broken_glass = 20;
   */
  brokenGlass: number[];
};

/**
 * Describes the message gunrun.v1.Welcome.
 * Use `create(WelcomeSchema)` to create a new message.
 */
export const WelcomeSchema: GenMessage<Welcome> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 15);

/**
 * Breakable brushes (glass panes) broke in server tick `tick`, after that tick's movement: they
 * block nothing (players, shots, sight) from tick + 1 on. One message per tick with breaks.
 *
 * @generated from message gunrun.v1.GlassBroken
 */
export type GlassBroken = Message<"gunrun.v1.GlassBroken"> & {
  /**
   * @generated from field: uint32 tick = 1;
   */
  tick: number;

  /**
   * @generated from field: repeated gunrun.v1.BrokenPane panes = 2;
   */
  panes: BrokenPane[];
};

/**
 * Describes the message gunrun.v1.GlassBroken.
 * Use `create(GlassBrokenSchema)` to create a new message.
 */
export const GlassBrokenSchema: GenMessage<GlassBroken> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 16);

/**
 * @generated from message gunrun.v1.BrokenPane
 */
export type BrokenPane = Message<"gunrun.v1.BrokenPane"> & {
  /**
   * index into the map's brushes
   *
   * @generated from field: uint32 brush = 1;
   */
  brush: number;

  /**
   * where the pane was hit
   *
   * @generated from field: gunrun.v1.Vec3 at = 2;
   */
  at?: Vec3 | undefined;

  /**
   * velocity the shards leave with, m/s (toward where the hit went)
   *
   * @generated from field: gunrun.v1.Vec3 push = 3;
   */
  push?: Vec3 | undefined;
};

/**
 * Describes the message gunrun.v1.BrokenPane.
 * Use `create(BrokenPaneSchema)` to create a new message.
 */
export const BrokenPaneSchema: GenMessage<BrokenPane> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 17);

/**
 * Every broken pane is whole again (a new match, a new round, everybody respawns).
 *
 * @generated from message gunrun.v1.GlassRestored
 */
export type GlassRestored = Message<"gunrun.v1.GlassRestored"> & {
};

/**
 * Describes the message gunrun.v1.GlassRestored.
 * Use `create(GlassRestoredSchema)` to create a new message.
 */
export const GlassRestoredSchema: GenMessage<GlassRestored> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 18);

/**
 * @generated from message gunrun.v1.PlayerLeft
 */
export type PlayerLeft = Message<"gunrun.v1.PlayerLeft"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;
};

/**
 * Describes the message gunrun.v1.PlayerLeft.
 * Use `create(PlayerLeftSchema)` to create a new message.
 */
export const PlayerLeftSchema: GenMessage<PlayerLeft> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 19);

/**
 * @generated from message gunrun.v1.Spawned
 */
export type Spawned = Message<"gunrun.v1.Spawned"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: gunrun.v1.Vec3 pos = 2;
   */
  pos?: Vec3 | undefined;

  /**
   * radians
   *
   * @generated from field: float yaw = 3;
   */
  yaw: number;

  /**
   * @generated from field: uint32 tick = 4;
   */
  tick: number;

  /**
   * exact PlayerSimState bytes; only in the receiver's own spawn
   *
   * @generated from field: bytes sim = 5;
   */
  sim: Uint8Array;

  /**
   * resolved loadout; only in the receiver's own spawn
   *
   * @generated from field: optional gunrun.v1.Loadout loadout = 6;
   */
  loadout?: Loadout | undefined;
};

/**
 * Describes the message gunrun.v1.Spawned.
 * Use `create(SpawnedSchema)` to create a new message.
 */
export const SpawnedSchema: GenMessage<Spawned> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 20);

/**
 * To the shooter. `damage` sums all pellets that landed this tick.
 *
 * @generated from message gunrun.v1.Hit
 */
export type Hit = Message<"gunrun.v1.Hit"> & {
  /**
   * @generated from field: uint32 target = 1;
   */
  target: number;

  /**
   * @generated from field: uint32 damage = 2;
   */
  damage: number;

  /**
   * @generated from field: gunrun.v1.HitZone zone = 3;
   */
  zone: HitZone;

  /**
   * @generated from field: bool killed = 4;
   */
  killed: boolean;

  /**
   * @generated from field: uint32 tick = 5;
   */
  tick: number;
};

/**
 * Describes the message gunrun.v1.Hit.
 * Use `create(HitSchema)` to create a new message.
 */
export const HitSchema: GenMessage<Hit> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 21);

/**
 * To the victim. `attacker` is absent for the world and the bomb; `from` is the damage source position.
 *
 * @generated from message gunrun.v1.Damaged
 */
export type Damaged = Message<"gunrun.v1.Damaged"> & {
  /**
   * @generated from field: optional uint32 attacker = 1;
   */
  attacker?: number | undefined;

  /**
   * @generated from field: uint32 damage = 2;
   */
  damage: number;

  /**
   * @generated from field: uint32 health = 3;
   */
  health: number;

  /**
   * @generated from field: gunrun.v1.Vec3 from = 4;
   */
  from?: Vec3 | undefined;

  /**
   * @generated from field: uint32 tick = 5;
   */
  tick: number;
};

/**
 * Describes the message gunrun.v1.Damaged.
 * Use `create(DamagedSchema)` to create a new message.
 */
export const DamagedSchema: GenMessage<Damaged> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 22);

/**
 * @generated from message gunrun.v1.KillSource
 */
export type KillSource = Message<"gunrun.v1.KillSource"> & {
  /**
   * @generated from oneof gunrun.v1.KillSource.source
   */
  source: {
    /**
     * weapon id
     *
     * @generated from field: string weapon = 1;
     */
    value: string;
    case: "weapon";
  } | {
    /**
     * equipment id
     *
     * @generated from field: string equipment = 2;
     */
    value: string;
    case: "equipment";
  } | {
    /**
     * @generated from field: bool bomb = 3;
     */
    value: boolean;
    case: "bomb";
  } | {
    /**
     * falls, out of bounds
     *
     * @generated from field: bool world = 4;
     */
    value: boolean;
    case: "world";
  } | {
    /**
     * @generated from field: bool suicide = 5;
     */
    value: boolean;
    case: "suicide";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gunrun.v1.KillSource.
 * Use `create(KillSourceSchema)` to create a new message.
 */
export const KillSourceSchema: GenMessage<KillSource> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 23);

/**
 * Broadcast: kill feed.
 *
 * @generated from message gunrun.v1.Killed
 */
export type Killed = Message<"gunrun.v1.Killed"> & {
  /**
   * @generated from field: optional uint32 killer = 1;
   */
  killer?: number | undefined;

  /**
   * @generated from field: uint32 victim = 2;
   */
  victim: number;

  /**
   * @generated from field: optional uint32 assister = 3;
   */
  assister?: number | undefined;

  /**
   * @generated from field: gunrun.v1.KillSource source = 4;
   */
  source?: KillSource | undefined;

  /**
   * @generated from field: bool headshot = 5;
   */
  headshot: boolean;

  /**
   * @generated from field: bool noscope = 6;
   */
  noscope: boolean;

  /**
   * @generated from field: bool midair = 7;
   */
  midair: boolean;

  /**
   * @generated from field: bool wallrun = 8;
   */
  wallrun: boolean;

  /**
   * @generated from field: bool longshot = 9;
   */
  longshot: boolean;

  /**
   * @generated from field: bool sliding = 10;
   */
  sliding: boolean;
};

/**
 * Describes the message gunrun.v1.Killed.
 * Use `create(KilledSchema)` to create a new message.
 */
export const KilledSchema: GenMessage<Killed> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 24);

/**
 * @generated from message gunrun.v1.ScoreEntry
 */
export type ScoreEntry = Message<"gunrun.v1.ScoreEntry"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;

  /**
   * @generated from field: uint32 kills = 2;
   */
  kills: number;

  /**
   * @generated from field: uint32 deaths = 3;
   */
  deaths: number;

  /**
   * @generated from field: uint32 assists = 4;
   */
  assists: number;

  /**
   * @generated from field: int32 score = 5;
   */
  score: number;

  /**
   * hill seconds, plants and defuses, ...
   *
   * @generated from field: uint32 objective = 6;
   */
  objective: number;

  /**
   * @generated from field: uint32 ping_ms = 7;
   */
  pingMs: number;
};

/**
 * Describes the message gunrun.v1.ScoreEntry.
 * Use `create(ScoreEntrySchema)` to create a new message.
 */
export const ScoreEntrySchema: GenMessage<ScoreEntry> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 25);

/**
 * @generated from message gunrun.v1.Scoreboard
 */
export type Scoreboard = Message<"gunrun.v1.Scoreboard"> & {
  /**
   * @generated from field: repeated gunrun.v1.ScoreEntry entries = 1;
   */
  entries: ScoreEntry[];
};

/**
 * Describes the message gunrun.v1.Scoreboard.
 * Use `create(ScoreboardSchema)` to create a new message.
 */
export const ScoreboardSchema: GenMessage<Scoreboard> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 26);

/**
 * @generated from message gunrun.v1.RoundStarted
 */
export type RoundStarted = Message<"gunrun.v1.RoundStarted"> & {
  /**
   * @generated from field: uint32 round = 1;
   */
  round: number;

  /**
   * @generated from field: gunrun.v1.Team attackers = 2;
   */
  attackers: Team;
};

/**
 * Describes the message gunrun.v1.RoundStarted.
 * Use `create(RoundStartedSchema)` to create a new message.
 */
export const RoundStartedSchema: GenMessage<RoundStarted> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 27);

/**
 * @generated from message gunrun.v1.RoundEnded
 */
export type RoundEnded = Message<"gunrun.v1.RoundEnded"> & {
  /**
   * @generated from field: uint32 round = 1;
   */
  round: number;

  /**
   * @generated from field: gunrun.v1.Team winner = 2;
   */
  winner: Team;

  /**
   * @generated from field: gunrun.v1.RoundEndReason reason = 3;
   */
  reason: RoundEndReason;
};

/**
 * Describes the message gunrun.v1.RoundEnded.
 * Use `create(RoundEndedSchema)` to create a new message.
 */
export const RoundEndedSchema: GenMessage<RoundEnded> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 28);

/**
 * @generated from message gunrun.v1.HillMoved
 */
export type HillMoved = Message<"gunrun.v1.HillMoved"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;

  /**
   * tick the new hill starts scoring
   *
   * @generated from field: uint32 active_tick = 2;
   */
  activeTick: number;
};

/**
 * Describes the message gunrun.v1.HillMoved.
 * Use `create(HillMovedSchema)` to create a new message.
 */
export const HillMovedSchema: GenMessage<HillMoved> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 29);

/**
 * @generated from message gunrun.v1.HillCaptured
 */
export type HillCaptured = Message<"gunrun.v1.HillCaptured"> & {
  /**
   * @generated from field: uint32 index = 1;
   */
  index: number;

  /**
   * @generated from field: gunrun.v1.Team team = 2;
   */
  team: Team;
};

/**
 * Describes the message gunrun.v1.HillCaptured.
 * Use `create(HillCapturedSchema)` to create a new message.
 */
export const HillCapturedSchema: GenMessage<HillCaptured> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 30);

/**
 * @generated from message gunrun.v1.BombPlanted
 */
export type BombPlanted = Message<"gunrun.v1.BombPlanted"> & {
  /**
   * 0 = A, 1 = B
   *
   * @generated from field: uint32 site = 1;
   */
  site: number;

  /**
   * @generated from field: uint32 by = 2;
   */
  by: number;
};

/**
 * Describes the message gunrun.v1.BombPlanted.
 * Use `create(BombPlantedSchema)` to create a new message.
 */
export const BombPlantedSchema: GenMessage<BombPlanted> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 31);

/**
 * @generated from message gunrun.v1.BombDefused
 */
export type BombDefused = Message<"gunrun.v1.BombDefused"> & {
  /**
   * @generated from field: uint32 by = 1;
   */
  by: number;
};

/**
 * Describes the message gunrun.v1.BombDefused.
 * Use `create(BombDefusedSchema)` to create a new message.
 */
export const BombDefusedSchema: GenMessage<BombDefused> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 32);

/**
 * @generated from message gunrun.v1.BombExploded
 */
export type BombExploded = Message<"gunrun.v1.BombExploded"> & {
};

/**
 * Describes the message gunrun.v1.BombExploded.
 * Use `create(BombExplodedSchema)` to create a new message.
 */
export const BombExplodedSchema: GenMessage<BombExploded> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 33);

/**
 * @generated from message gunrun.v1.BombDropped
 */
export type BombDropped = Message<"gunrun.v1.BombDropped"> & {
  /**
   * @generated from field: gunrun.v1.Vec3 pos = 1;
   */
  pos?: Vec3 | undefined;
};

/**
 * Describes the message gunrun.v1.BombDropped.
 * Use `create(BombDroppedSchema)` to create a new message.
 */
export const BombDroppedSchema: GenMessage<BombDropped> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 34);

/**
 * @generated from message gunrun.v1.BombPickedUp
 */
export type BombPickedUp = Message<"gunrun.v1.BombPickedUp"> & {
  /**
   * @generated from field: uint32 by = 1;
   */
  by: number;
};

/**
 * Describes the message gunrun.v1.BombPickedUp.
 * Use `create(BombPickedUpSchema)` to create a new message.
 */
export const BombPickedUpSchema: GenMessage<BombPickedUp> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 35);

/**
 * @generated from message gunrun.v1.Halftime
 */
export type Halftime = Message<"gunrun.v1.Halftime"> & {
};

/**
 * Describes the message gunrun.v1.Halftime.
 * Use `create(HalftimeSchema)` to create a new message.
 */
export const HalftimeSchema: GenMessage<Halftime> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 36);

/**
 * @generated from message gunrun.v1.MatchPoint
 */
export type MatchPoint = Message<"gunrun.v1.MatchPoint"> & {
  /**
   * @generated from field: gunrun.v1.Team team = 1;
   */
  team: Team;
};

/**
 * Describes the message gunrun.v1.MatchPoint.
 * Use `create(MatchPointSchema)` to create a new message.
 */
export const MatchPointSchema: GenMessage<MatchPoint> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 37);

/**
 * @generated from message gunrun.v1.ModeEvent
 */
export type ModeEvent = Message<"gunrun.v1.ModeEvent"> & {
  /**
   * @generated from oneof gunrun.v1.ModeEvent.event
   */
  event: {
    /**
     * @generated from field: gunrun.v1.RoundStarted round_started = 1;
     */
    value: RoundStarted;
    case: "roundStarted";
  } | {
    /**
     * @generated from field: gunrun.v1.RoundEnded round_ended = 2;
     */
    value: RoundEnded;
    case: "roundEnded";
  } | {
    /**
     * @generated from field: gunrun.v1.HillMoved hill_moved = 3;
     */
    value: HillMoved;
    case: "hillMoved";
  } | {
    /**
     * @generated from field: gunrun.v1.HillCaptured hill_captured = 4;
     */
    value: HillCaptured;
    case: "hillCaptured";
  } | {
    /**
     * @generated from field: gunrun.v1.BombPlanted bomb_planted = 5;
     */
    value: BombPlanted;
    case: "bombPlanted";
  } | {
    /**
     * @generated from field: gunrun.v1.BombDefused bomb_defused = 6;
     */
    value: BombDefused;
    case: "bombDefused";
  } | {
    /**
     * @generated from field: gunrun.v1.BombExploded bomb_exploded = 7;
     */
    value: BombExploded;
    case: "bombExploded";
  } | {
    /**
     * @generated from field: gunrun.v1.BombDropped bomb_dropped = 8;
     */
    value: BombDropped;
    case: "bombDropped";
  } | {
    /**
     * @generated from field: gunrun.v1.BombPickedUp bomb_picked_up = 9;
     */
    value: BombPickedUp;
    case: "bombPickedUp";
  } | {
    /**
     * @generated from field: gunrun.v1.Halftime halftime = 10;
     */
    value: Halftime;
    case: "halftime";
  } | {
    /**
     * @generated from field: gunrun.v1.MatchPoint match_point = 11;
     */
    value: MatchPoint;
    case: "matchPoint";
  } | { case: undefined; value?: undefined };
};

/**
 * Describes the message gunrun.v1.ModeEvent.
 * Use `create(ModeEventSchema)` to create a new message.
 */
export const ModeEventSchema: GenMessage<ModeEvent> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 38);

/**
 * @generated from message gunrun.v1.PhaseChanged
 */
export type PhaseChanged = Message<"gunrun.v1.PhaseChanged"> & {
  /**
   * @generated from field: gunrun.v1.MatchPhase phase = 1;
   */
  phase: MatchPhase;

  /**
   * 0 = no timer
   *
   * @generated from field: uint32 end_tick = 2;
   */
  endTick: number;
};

/**
 * Describes the message gunrun.v1.PhaseChanged.
 * Use `create(PhaseChangedSchema)` to create a new message.
 */
export const PhaseChangedSchema: GenMessage<PhaseChanged> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 39);

/**
 * @generated from message gunrun.v1.MatchEnded
 */
export type MatchEnded = Message<"gunrun.v1.MatchEnded"> & {
  /**
   * team modes; absent on a draw
   *
   * @generated from field: optional gunrun.v1.Team winner_team = 1;
   */
  winnerTeam?: Team | undefined;

  /**
   * FFA
   *
   * @generated from field: optional uint32 winner_player = 2;
   */
  winnerPlayer?: number | undefined;

  /**
   * @generated from field: optional uint32 mvp = 3;
   */
  mvp?: number | undefined;

  /**
   * @generated from field: gunrun.v1.TeamScores scores = 4;
   */
  scores?: TeamScores | undefined;

  /**
   * @generated from field: repeated gunrun.v1.ScoreEntry entries = 5;
   */
  entries: ScoreEntry[];

  /**
   * map the room loads next when it cycles
   *
   * @generated from field: optional string next_map = 6;
   */
  nextMap?: string | undefined;

  /**
   * @generated from field: uint32 next_in_sec = 7;
   */
  nextInSec: number;
};

/**
 * Describes the message gunrun.v1.MatchEnded.
 * Use `create(MatchEndedSchema)` to create a new message.
 */
export const MatchEndedSchema: GenMessage<MatchEnded> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 40);

/**
 * @generated from message gunrun.v1.XpItem
 */
export type XpItem = Message<"gunrun.v1.XpItem"> & {
  /**
   * @generated from field: string label = 1;
   */
  label: string;

  /**
   * @generated from field: uint32 xp = 2;
   */
  xp: number;
};

/**
 * Describes the message gunrun.v1.XpItem.
 * Use `create(XpItemSchema)` to create a new message.
 */
export const XpItemSchema: GenMessage<XpItem> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 41);

/**
 * @generated from message gunrun.v1.WeaponLevelChange
 */
export type WeaponLevelChange = Message<"gunrun.v1.WeaponLevelChange"> & {
  /**
   * @generated from field: string weapon = 1;
   */
  weapon: string;

  /**
   * @generated from field: uint32 xp_gained = 2;
   */
  xpGained: number;

  /**
   * @generated from field: uint32 level_before = 3;
   */
  levelBefore: number;

  /**
   * @generated from field: uint32 level_after = 4;
   */
  levelAfter: number;
};

/**
 * Describes the message gunrun.v1.WeaponLevelChange.
 * Use `create(WeaponLevelChangeSchema)` to create a new message.
 */
export const WeaponLevelChangeSchema: GenMessage<WeaponLevelChange> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 42);

/**
 * Per-player end-of-match rewards, sent to that player only.
 *
 * @generated from message gunrun.v1.Rewards
 */
export type Rewards = Message<"gunrun.v1.Rewards"> & {
  /**
   * @generated from field: repeated gunrun.v1.XpItem xp_items = 1;
   */
  xpItems: XpItem[];

  /**
   * @generated from field: uint32 xp_total = 2;
   */
  xpTotal: number;

  /**
   * @generated from field: uint32 level_before = 3;
   */
  levelBefore: number;

  /**
   * @generated from field: uint32 level_after = 4;
   */
  levelAfter: number;

  /**
   * @generated from field: uint32 xp_into_level = 5;
   */
  xpIntoLevel: number;

  /**
   * 0 at max level
   *
   * @generated from field: uint32 xp_for_next = 6;
   */
  xpForNext: number;

  /**
   * labels of items unlocked by this match
   *
   * @generated from field: repeated string unlocked = 7;
   */
  unlocked: string[];

  /**
   * @generated from field: repeated gunrun.v1.WeaponLevelChange weapon_levels = 8;
   */
  weaponLevels: WeaponLevelChange[];

  /**
   * ranked only
   *
   * @generated from field: optional float rating_delta = 9;
   */
  ratingDelta?: number | undefined;

  /**
   * @generated from field: float rating = 10;
   */
  rating: number;
};

/**
 * Describes the message gunrun.v1.Rewards.
 * Use `create(RewardsSchema)` to create a new message.
 */
export const RewardsSchema: GenMessage<Rewards> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 43);

/**
 * @generated from message gunrun.v1.ChatMessage
 */
export type ChatMessage = Message<"gunrun.v1.ChatMessage"> & {
  /**
   * @generated from field: uint32 from = 1;
   */
  from: number;

  /**
   * @generated from field: bool team_only = 2;
   */
  teamOnly: boolean;

  /**
   * @generated from field: string text = 3;
   */
  text: string;
};

/**
 * Describes the message gunrun.v1.ChatMessage.
 * Use `create(ChatMessageSchema)` to create a new message.
 */
export const ChatMessageSchema: GenMessage<ChatMessage> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 44);

/**
 * @generated from message gunrun.v1.Notice
 */
export type Notice = Message<"gunrun.v1.Notice"> & {
  /**
   * @generated from field: gunrun.v1.NoticeKind kind = 1;
   */
  kind: NoticeKind;

  /**
   * @generated from field: string text = 2;
   */
  text: string;
};

/**
 * Describes the message gunrun.v1.Notice.
 * Use `create(NoticeSchema)` to create a new message.
 */
export const NoticeSchema: GenMessage<Notice> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 45);

/**
 * @generated from message gunrun.v1.Kicked
 */
export type Kicked = Message<"gunrun.v1.Kicked"> & {
  /**
   * @generated from field: string reason = 1;
   */
  reason: string;
};

/**
 * Describes the message gunrun.v1.Kicked.
 * Use `create(KickedSchema)` to create a new message.
 */
export const KickedSchema: GenMessage<Kicked> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 46);

/**
 * @generated from message gunrun.v1.HostChanged
 */
export type HostChanged = Message<"gunrun.v1.HostChanged"> & {
  /**
   * @generated from field: uint32 id = 1;
   */
  id: number;
};

/**
 * Describes the message gunrun.v1.HostChanged.
 * Use `create(HostChangedSchema)` to create a new message.
 */
export const HostChangedSchema: GenMessage<HostChanged> = /*@__PURE__*/
  messageDesc(file_gunrun_v1_game, 47);

/**
 * @generated from enum gunrun.v1.RoundEndReason
 */
export enum RoundEndReason {
  /**
   * @generated from enum value: ROUND_END_REASON_ELIMINATION = 0;
   */
  ELIMINATION = 0,

  /**
   * @generated from enum value: ROUND_END_REASON_BOMB_EXPLODED = 1;
   */
  BOMB_EXPLODED = 1,

  /**
   * @generated from enum value: ROUND_END_REASON_BOMB_DEFUSED = 2;
   */
  BOMB_DEFUSED = 2,

  /**
   * defenders win
   *
   * @generated from enum value: ROUND_END_REASON_TIME_OUT = 3;
   */
  TIME_OUT = 3,
}

/**
 * Describes the enum gunrun.v1.RoundEndReason.
 */
export const RoundEndReasonSchema: GenEnum<RoundEndReason> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_game, 0);

/**
 * @generated from enum gunrun.v1.NoticeKind
 */
export enum NoticeKind {
  /**
   * @generated from enum value: NOTICE_KIND_INFO = 0;
   */
  INFO = 0,

  /**
   * @generated from enum value: NOTICE_KIND_SUCCESS = 1;
   */
  SUCCESS = 1,

  /**
   * @generated from enum value: NOTICE_KIND_WARNING = 2;
   */
  WARNING = 2,

  /**
   * @generated from enum value: NOTICE_KIND_ERROR = 3;
   */
  ERROR = 3,
}

/**
 * Describes the enum gunrun.v1.NoticeKind.
 */
export const NoticeKindSchema: GenEnum<NoticeKind> = /*@__PURE__*/
  enumDesc(file_gunrun_v1_game, 1);

